import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";
import { apiCaller } from "../functions";

export function useSettingReturnApi() {
    const callApi = useApiCall();

    return {
        settingReturnInsertUpdate: apiCaller(callApi, SAGA_ACTIONS.SETTINGS_RETURN.SETTING_RETURN_INSERT_UPDATE),        
        getSettingReturnPolicy: apiCaller(callApi, SAGA_ACTIONS.SETTINGS_RETURN.GET_SETTING_RETURN_POLICY),
    };
}